import type { DietEntry } from '@diet/types';
import { formatCalories, MEAL_SLOT_LABELS } from '@diet/utils';
import type { MealGroupData } from '@diet/utils';
import { EntryRow } from './entry-row';

export interface MealGroupProps {
  group: MealGroupData;
  onSelectEntry: (entry: DietEntry) => void;
}

/**
 * 單一餐別區塊：標題列顯示餐別與小計，其下為該餐的紀錄（依建立順序）。
 */
export function MealGroup({ group, onSelectEntry }: MealGroupProps) {
  const label = MEAL_SLOT_LABELS[group.slot];

  return (
    <section className="flex flex-col gap-2" aria-label={label}>
      <div className="flex items-baseline justify-between px-1">
        <h2 className="font-display text-[0.8125rem] text-strong">{label}</h2>
        <span className="font-mono text-[0.6875rem] tabular-nums text-muted-foreground">
          {formatCalories(group.subtotal)} kcal
        </span>
      </div>

      <ul className="flex flex-col gap-2">
        {group.entries.map((entry) => (
          <EntryRow key={entry.id} entry={entry} onSelect={onSelectEntry} />
        ))}
      </ul>
    </section>
  );
}
